// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { LeaderboardRow } from '../entities/leaderboard.entity';

/**
 * Mock data for Technical Influence Leaderboard (v2)
 * Used for development, testing, and fallback scenarios
 */
export const TECHNICAL_INFLUENCE_LEADERBOARD_MOCK_DATA: LeaderboardRow[] = [
  {
    rank: 1,
    organizationName: 'Cloud Native Computing Foundation',
    organizationLogo: 'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://cncf.io&size=64',
    influenceScore: 17.3,
    influenceScoreLevel: 'Leading',
    isCurrentOrg: false
  },
  {
    rank: 2,
    organizationName: 'SUSE',
    organizationLogo: 'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://suse.com&size=64',
    influenceScore: 15.3,
    influenceScoreLevel: 'Leading',
    isCurrentOrg: false
  },
  {
    rank: 3,
    organizationName: 'Bloomberg Finance L.P.',
    organizationLogo: 'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://bloomberg.com&size=64',
    influenceScore: 11.3,
    influenceScoreLevel: 'Contributing',
    isCurrentOrg: false
  },
  {
    rank: 4,
    organizationName: 'Chainguard',
    organizationLogo: 'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://chainguard.dev&size=64',
    influenceScore: 11.0,
    influenceScoreLevel: 'Contributing',
    isCurrentOrg: false
  },
  {
    rank: 5,
    organizationName: 'mattfarina.com',
    organizationLogo: undefined,
    influenceScore: 9.6,
    influenceScoreLevel: 'Contributing',
    isCurrentOrg: false
  },
  {
    rank: 6,
    organizationName: 'Google LLC',
    organizationLogo: 'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://google.com&size=64',
    influenceScore: 8.5,
    influenceScoreLevel: 'Contributing',
    isCurrentOrg: false
  },
  {
    rank: 7,
    organizationName: 'Microsoft Corporation',
    organizationLogo: 'https://avatars.githubusercontent.com/u/6154722?s=200&v=4',
    influenceScore: 7.2,
    influenceScoreLevel: 'Participating',
    isCurrentOrg: false
  },
  {
    rank: 8,
    organizationName: 'Red Hat, Inc.',
    organizationLogo: 'https://avatars.githubusercontent.com/u/33972111?s=200&v=4',
    influenceScore: 6.8,
    influenceScoreLevel: 'Participating',
    isCurrentOrg: false
  },
  {
    rank: 9,
    organizationName: 'VMware LLC',
    organizationLogo: 'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vmware.com&size=64',
    influenceScore: 5.4,
    influenceScoreLevel: 'Participating',
    isCurrentOrg: false
  },
  {
    rank: 10,
    organizationName: 'Intel Corporation',
    organizationLogo: 'https://avatars.githubusercontent.com/u/17888862?s=200&v=4',
    influenceScore: 4.1,
    influenceScoreLevel: 'Silent',
    isCurrentOrg: true
  }
];
